import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put('update/fee-details', payload)
}
